<template>
  <el-dialog class="rc-dialog" title="手动报到" :visible.sync="showTrainModal.flag" width="40%" top="30vh"
    :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
    <el-form class="form" size="small" label-position="right" label-width="100px" :rules="rules" :model="trainForm"
      ref="trainForm">
      <el-row>
        <el-col :span="24">
          <el-form-item label="报到状态：" prop="clockStatus">
            <el-select class="wth_220" v-model="trainForm.clockStatus" placeholder="请选择报到状态">
              <el-option v-for="item in clockStatusData" :key="item.paramKey" :label="item.paramValue"
                :value="Number(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="Number(trainForm.clockStatus) == 2">
          <el-form-item label="报到时间：" prop="clockTime">
            <el-date-picker class="date-picker" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
              size="small" v-model="trainForm.clockTime" type="datetime" placeholder="报到时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注：" prop="remarks">
        <el-input type="textarea" :rows="5" maxlength="500" show-word-limit v-model="trainForm.remarks"
          placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import { updateClockStatus } from "@/api/class";
export default {
  components: {
  },
  props: {
    showTrainModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    classItem: {
      type: Object,
      default: () => { },
    }
  },
  data() {
    return {
      trainForm: {
        clockTime: "",
        clockStatus: "",
        enrollId: "",
        remarks: "",
      },
      clockStatusData: [],
      rules: {
        clockStatus: [{ required: true, message: "请选择报到状态" }],
        clockTime: [
          {
            required: true,
            message: "请选择报到时间",
            trigger: "blur, change",
          }
        ],
      },
    };
  },
  created() {
    this.getSysParamByTypes(["CLOCK_STATUS"]);
    this.trainForm = {
      clockStatus: this.classItem.clockStatus,
      enrollId: this.classItem.uuid,
      clockTime: this.classItem.clockTime,
      remarks: this.classItem.remarks
    }
  },
  methods: {
    cancel() {
      this.$emit("closeTrainModal");
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.clockStatusData = res.data["CLOCK_STATUS"];
      });
    },
    submit() {
      if (this.trainForm.clockStatus == 2 && !this.trainForm.clockTime) {
        this.$message({
          message: "请选择报到时间",
          type: "error"
        });
        return;
      }
      if (!this.trainForm.clockStatus) {
        this.$message({
          message: "请选择报到状态",
          type: "error"
        });
        return;
      }
      this.updateClockStatus();
    },
    updateClockStatus() {
      let params = {
        ...this.trainForm,
      };
      if (params.clockStatus == 1) {
        delete params.clockTime;
      }
      updateClockStatus(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.cancel();
        this.$parent.reload();
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    overflow: hidden;
    padding-bottom: 16px;

    .form-select {
      width: 80%;
    }
  }

  .wth_220 {
    width: 220px;
  }
}
</style>
